// /reports/inspection-addresses?saleId={id}

import { Fetch } from "./util/InterceptedFetch";
import { BuildUri } from "./util/BuildUri";

//Model
// InspectionAddressReports

export class ReportsEndpoints {
    constructor(private fetch: Fetch) {}

    getInspectionAddress(saleId: number): Promise<string> {
        return this.fetch(BuildUri("/report/html/addresses-for-inspection"), { method: "POST", body: { saleId: saleId } });
    }

    getComplianceStatus(saleId: number): Promise<string> {
        return this.fetch(BuildUri("/report/html/horse-for-sale-non-compliance"), { method: "POST", body: { saleId: saleId } });
    }

    getHipNumAndConsignors(saleId: number, consignorId: number): Promise<string> {
        return this.fetch(BuildUri("/report/html/hip-number-export"), { method: "POST", body: { saleId: saleId, consignorId: consignorId } });
    }

    getSalePreview(saleId: number): Promise<string> {
        return this.fetch(BuildUri("/report/html/horse-for-sale-preview"), { method: "POST", body: { saleId: saleId } });
    }

    getCatalogInformation(saleId: number): Promise<string> {
        return this.fetch(BuildUri("/report/html/info-for-catalog"), { method: "POST", body: { saleId: saleId } });
    }

    getIndexes(saleId: number, indexName: string): Promise<string> {
        return this.fetch(BuildUri(`/report/html/${indexName}`), { method: "POST", body: { saleId: saleId } });
    }

    getFullCircleEnrollment(saleId: number): Promise<string> {
        return this.fetch(BuildUri(`/report/html/full-circle-enrollment`), { method: "POST", body: { saleId: saleId } });
    }

    getHFSMasterlist(saleId: number): Promise<string> {
        return this.fetch(BuildUri(`/report/html/horse-for-sale-master-list`), { method: "POST", body: { saleId: saleId } });
    }

    getBuyerInsuranceReport(saleId: number, companyId: number): Promise<string> {
        return this.fetch(BuildUri(`/report/html/buyer-insurance`), { method: "POST", body: { saleId: saleId, companyId: companyId } });
    }

    getHorsesWithdrawnWithoutVetCertificateReport(saleId: number, consignorId: number): Promise<string> {
        return this.fetch(BuildUri("/report/html/horses-withdrawn-without-vet-certificate"), {
            method: "POST",
            body: { saleId: saleId, consignorId: consignorId }
        });
    }

    getStakeEngagementListReport(saleId: number, horseForSaleId: number): Promise<string> {
        return this.fetch(BuildUri(`/report/html/stake-engagement-list`), {
            method: "POST",
            body: { saleId: saleId, horseForSaleId: horseForSaleId }
        });
    }

    getFinalSale(saleId: number): Promise<string> {
        return this.fetch(BuildUri(`/report/html/final-sale-report`), { method: "POST", body: { saleId: saleId } });
    }

    getFinancialSummary(fromDate: number, toDate: number): Promise<string> {
        return this.fetch(BuildUri(`/report/html/financial-summary`), { method: "POST", body: { fromDate: fromDate, toDate: toDate } });
    }

    getCustomerEmail(saleId: number, role: string): Promise<string> {
        return this.fetch(BuildUri(`/report/html/customer-emails`), { method: "POST", body: { saleId: saleId, role: role } });
    }

    getFinalSaleReportForSelectedConsignor(saleId: number, consignorId: number): Promise<string> {
        return this.fetch(BuildUri(`/report/html/financials-by-consignor`), {
            method: "POST",
            body: { saleId: saleId, consignorId: consignorId }
        });
    }

    getHorsesByYear(year: string): Promise<string> {
        return this.fetch(BuildUri(`/report/html/horses-by-year`), { method: "POST", body: { year } });
    }
}



// WEBPACK FOOTER //
// ./src/endpoints/ReportsEndpoints.ts